export default "__VITE_ASSET__BNrHqSCK__"